import { message } from "antd";
import {filter, isEmpty, isEqual, map} from "lodash";
import moment from "moment-timezone";
import React, { Component } from "react";
import Header from "../../../Common/Component/Header";
import Loader from "../../../Common/Component/Loader";
import Sidebar from "../../../Common/Component/Sidebar";
import BillingInfo from "./BillingInfo";
import ServiceInfo from "./ServiceInfo";
import {errorHandle} from "../../../Common/errorHandle";

class QuoteNewService extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      zipcodeCheck: null,
      franchises: [],
      leadData: '',
      currentTab: 0,
      enquiryList: {},
      field_office_uuid: '',
      isBackClick: false,
      prePaydata:{},
      role: null,
    }
  }

  UNSAFE_componentWillMount = () => {
    sessionStorage.clear();
  }

  componentDidMount = () => {
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    this.props.resetCheckZipcode();
    this.props.resetPricingCalculator();
    this.props.getServiceOrderEnquiry({user__uuid: id, limit: 1}); // get service order enquiry
    this.props.getLeadById(id);
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {

    // errors handle
    if (Object.keys(nextProps?.ZipcodeCheck?.errors).length > 0 && nextProps?.ZipcodeCheck?.errors !== this.props?.ZipcodeCheck?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.ZipcodeCheck?.errors)
    }

    if (Object.keys(nextProps?.Lead?.errors).length > 0 && nextProps?.Lead?.errors !== this.props?.Lead?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.Lead?.errors)
    }
    //////////////////////////

    // check zipcode
    if (Object.keys(nextProps?.ZipcodeCheck?.data).length > 0 && nextProps?.ZipcodeCheck?.data?.results?.length > 0) {
      this.setState({loader: false});
      this.setState({zipcodeCheck: true, franchises: nextProps?.ZipcodeCheck?.data?.results, field_office_uuid: nextProps?.ZipcodeCheck?.data?.results?.[0]?.uuid});
    } else {
      this.setState({loader: false});
      this.setState({zipcodeCheck: false, franchises: []});
    }

    // get lead customer data
    if (nextProps?.Lead && Object.keys(nextProps?.Lead?.getLead).length > 0) {
      this.setState({loader: false});
      this.setState({leadData: nextProps?.Lead?.getLead})
    }

    // get service order enquiry
    if (Object.keys(nextProps?.ServiceOrderEnquiry?.enquiryList).length > 0
      && JSON.stringify(nextProps?.ServiceOrderEnquiry?.enquiryList) !== JSON.stringify(this.state.enquiryList)) {
      this.setState({loader: false});
      this.setState({enquiryList: nextProps?.ServiceOrderEnquiry?.enquiryList, field_office_uuid: nextProps?.ServiceOrderEnquiry?.enquiryList?.results?.[0]?.field_office_uuid});
      if (this.state.enquiryList?.results?.count > 0) {
        let {coupon_code, prepay_months, is_prepaid} = this.state.enquiryList.results[0];
        this.setPrePayData({coupon_code,prepay_months,is_prepaid});
      } 
   
    }

    // get service order enquiry
    if (Object.keys(nextProps?.ServiceOrderEnquiry?.nonServiceableEnquiry).length > 0
      && JSON.stringify(nextProps?.ServiceOrderEnquiry?.nonServiceableEnquiry) !== JSON.stringify(this.props?.ServiceOrderEnquiry?.nonServiceableEnquiry)) {
      this.setState({loader: false});
      message.success('Will contact you soon', 10)
      setTimeout(() => this.props.history && this.props.history.goBack(), 1000)
    }
  }

  // on tab change
  onTabChange = (value, isBackClick = false) => {
    this.setState({currentTab: value, isBackClick})
  };

  // set value for loader
  setLoader = (value) => {
    this.setState({loader: value})
  };

  // on add enquiry
  onAddEnquiry = (type) => {
    return new Promise((resolve, reject) => {
      const {field_office_uuid, enquiryList} = this.state;
      const {PricingCalc, history} = this.props;
      const id = history?.location?.state?.query?.id;

      const basicDetail = JSON.parse(sessionStorage.getItem('basicDetail'));
      const step1Data = JSON.parse(sessionStorage.getItem('step1'));
      const step2Data = JSON.parse(sessionStorage.getItem('step2'));
      const calcData = JSON.parse(sessionStorage.getItem('calcData'));

      if (field_office_uuid) {
        this.setState({loader: true});
        const service_add_ons = [];
        
        map(step1Data?.add_ons, obj => {
          if (obj?.add_on_uuid)
          {
            service_add_ons.push({
              add_on_uuid: obj?.add_on_uuid,
              add_on_name: obj?.name,
              is_recurring: obj?.is_recurring || false
            });
          }
        });

        if (!basicDetail?.address?.geo_location) {
          delete basicDetail?.address?.geo_location;
        }

        if (!step2Data?.address?.geo_location) {
          delete step2Data?.address?.geo_location;
        }

        map(basicDetail?.phone_numbers, (obj) => {
          if(!obj.uuid) delete obj?.uuid
        })

        let area_to_clean = [];
        
        if (step1Data?.areaClean && step1Data?.areaClean.length > 0) {
          area_to_clean = step1Data?.areaClean;

          const idx = area_to_clean.indexOf("");

          if (idx > -1) {
            area_to_clean[idx] = step1Data?.otherCleaning;
          }
        }

        const obj = {
          first_name: basicDetail?.firstName || '',
          email: basicDetail?.leadData?.email,
          phone_numbers: basicDetail?.phone_numbers,
          hear_about_us: basicDetail?.hear_about_us || '',
          field_office_uuid: basicDetail?.field_office_uuid,
          outreach : basicDetail?.leadData.outreach || '',
          service_type: 'residential',
          property_type: step1Data?.propertyType ? step1Data?.propertyType : null,
          service_add_ons,
          pets: [],
          area_to_clean: area_to_clean,
          last_cleaned: step1Data?.lastCleaned,
          service_address: (basicDetail?.address?.street_number && basicDetail?.address?.route) ? {...basicDetail?.address, address: `${basicDetail?.address?.street_number} ${basicDetail?.address?.route}`} : basicDetail?.address,
       
          disposal_location: step1Data?.disposalLocation,
          cleaning_notes: step1Data?.cleaningNotes,
          // pricing
          calculated_price: PricingCalc?.data ? PricingCalc?.data : null,
          coupon_code: calcData?.coupon_code ? calcData?.coupon_code : '',
          is_enquiry: true,
          user: JSON.parse(localStorage.getItem('authUser'))?.user?.uuid,
          user_uuid: id,
      
          is_prepaid: PricingCalc?.data?.is_prepaid,
          prepay_months: PricingCalc?.data?.prepay_months
        }

        if (step1Data?.frequency) {
          Object.assign(obj, {frequency: step1Data?.frequency})
        }
        if (step1Data?.is_extra_pet || step1Data?.dogCount) {
          Object.assign(obj, {pet_count: step1Data?.is_extra_pet ? step1Data?.extra_pet : step1Data?.dogCount})
        }
        if (type === 'step2') {
          Object.assign(obj, {
            is_print_and_mail_invoices:step2Data.print_invoice_card,
            is_email_invoice:step2Data.email_invoice,
            is_terms_accepted:step2Data.isAgreed,
            charge_invoice_card:step2Data.charge_invoice_card,
            preferred_start_date: step2Data?.preferred_start_date ? moment(step2Data?.preferred_start_date).format('YYYY-MM-DD') : null,
            preferred_contact_methods: step2Data?.contactMethods,
          })
          if(step2Data?.user_billing_info_uuid){
            Object.assign(obj, {user_billing_info_uuid:step2Data?.user_billing_info_uuid})
          }
           
          if(step2Data && step2Data.payment_method){
            Object.assign(obj, {payment_method_type:step2Data?.payment_method})
          }
            
        }
        if (basicDetail?.lastName) {
          Object.assign(obj, {last_name: basicDetail?.lastName })
        }
        
       
        if (step2Data && step2Data?.address){
          Object.assign(obj, {is_billing_address_same: step2Data.isBillingAddress, billing_address: step2Data.address })
        }
        else if(!enquiryList?.results?.[0]){
          let address =   (basicDetail?.address?.street_number && basicDetail?.address?.route) ? {...basicDetail?.address, address: `${basicDetail?.address?.street_number} ${basicDetail?.address?.route}`} : basicDetail?.address;
          Object.assign(obj, {is_billing_address_same: true, billing_address: address })
        }
        else if(enquiryList?.results?.[0]){
          Object.assign(obj, {is_billing_address_same: enquiryList?.results?.[0]?.is_billing_address_same, billing_address: enquiryList?.results?.[0].billing_address })
        }
       
        
        if (enquiryList?.results?.[0]?.uuid) {
          // update service order enquiry
          return this.props.updateServiceOrderEnquiry({uuid: enquiryList?.results?.[0]?.uuid, ...obj})
            .then(res => {
              this.updateLeadDetail('lead');
              return resolve(res)
            }).catch(error => {
              return reject(error)
            });
        } else {
          //add service order enquiry
          return this.props.addServiceOrderEnquiry(obj)
            .then(res => {
              this.props.getServiceOrderEnquiry({user__uuid: this.props.history?.location?.state?.query?.id, limit: 1});
              this.updateLeadDetail('lead');
              resolve(res)
            }).catch(error => {
              reject(error)
            });
          
        }
      }
    })
  }

  // on convert to customer
  onConvertToCustomer = () => {
    return new Promise((resolve, reject) => {
      const {field_office_uuid, leadData, enquiryList} = this.state;
      const {PricingCalc, history} = this.props;
      const id = history?.location?.state?.query?.id;

      const basicDetail = JSON.parse(sessionStorage.getItem('basicDetail'));
      const step1Data = JSON.parse(sessionStorage.getItem('step1'));
      const step2Data = JSON.parse(sessionStorage.getItem('step2'));
      const calcData = JSON.parse(sessionStorage.getItem('calcData'));

      if (field_office_uuid && field_office_uuid !== basicDetail.field_office_uuid) {
        this.setState({loader: true});
        const service_add_ons = []
        map(step1Data?.add_ons, obj => {
          if (obj?.add_on_uuid) service_add_ons.push({add_on_uuid: obj?.add_on_uuid, add_on_name: obj?.name, is_recurring: obj?.is_recurring || false})
        });

        const isBillingAddress = isEqual(basicDetail?.address?.formatted_address, step2Data?.address?.formatted_address)

        if (!basicDetail?.address?.geo_location) {
          delete basicDetail?.address?.geo_location
        }
        if (!step2Data?.address?.geo_location) {
          delete step2Data?.address?.geo_location
        }
        map(basicDetail?.phone_numbers, (obj) => {
          if(!obj.uuid) delete obj?.uuid
        })

        let obj = {
          first_name: basicDetail?.firstName || '',
          email: leadData?.email,
          hear_about_us: basicDetail?.hear_about_us || '',
          phone_numbers: basicDetail?.phone_numbers,
          field_office_uuid: field_office_uuid,
          service_type: 'residential',
          property_type: step1Data?.propertyType ? step1Data?.propertyType : null,
          service_add_ons,
          pets: [],
          area_to_clean: step1Data?.areaClean,
          last_cleaned: step1Data?.lastCleaned,
          service_address: (basicDetail?.address?.street_number && basicDetail?.address?.route) ? {...basicDetail?.address, address: `${basicDetail?.address?.street_number} ${basicDetail?.address?.route}`} : basicDetail?.address,
          disposal_location: step1Data?.disposalLocation,
          cleaning_notes: step1Data?.cleaningNotes,
          preferred_start_date: step2Data?.preferred_start_date &&  step2Data?.preferred_start_date !== '' ? moment(step2Data?.preferred_start_date, 'YYYY-MM-DD').format('YYYY-MM-DD') : null,
          is_billing_address_same: isBillingAddress,
          billing_address:step2Data.address,
          // billing_address: isBillingAddress ? null : (step2Data?.address?.street_number && step2Data?.address?.route) ? {...step2Data?.address, address: `${step2Data?.address?.street_number} ${step2Data?.address?.route}`} : step2Data?.address,
          preferred_contact_methods: step2Data?.contactUs,
          // stripe_payment_method_dict: {card: step2Data?.stripe_payment_method_dict},
          // user_billing_info_uuid: step2Data?.user_billing_info_uuid ? step2Data?.user_billing_info_uuid : null,
          // stripe_card_details: {card: step2Data?.stripe_card_details ? step2Data?.stripe_card_details : {}},
          calculated_price: PricingCalc?.data ? PricingCalc?.data : null,
          coupon_code: calcData?.coupon_code ? calcData?.coupon_code : '',
          is_enquiry: false,
          user: JSON.parse(localStorage.getItem('authUser'))?.user?.uuid,
          user_uuid: id,
          is_prepaid: PricingCalc?.data?.is_prepaid,
          prepay_months: PricingCalc?.data?.prepay_months,
          is_print_and_mail_invoices:step2Data.print_invoice_card,
          is_email_invoice:step2Data.email_invoice,
        }
        if(step2Data?.user_billing_info_uuid){
          Object.assign(obj, {user_billing_info_uuid:step2Data?.user_billing_info_uuid})
        }

        if(step2Data && step2Data.payment_method){
          Object.assign(obj, {payment_method_type:step2Data?.payment_method})
        }

        if (step1Data?.frequency) {
          Object.assign(obj, {frequency: step1Data?.frequency})
        }
        if (step1Data?.is_extra_pet || step1Data?.dogCount) {
          Object.assign(obj, {pet_count: step1Data?.is_extra_pet ? step1Data?.extra_pet : step1Data?.dogCount})
        }
        if (basicDetail?.lastName) {
          Object.assign(obj, {last_name: basicDetail?.lastName })
        }

        if (enquiryList?.results?.[0]?.uuid) {
          // update service order enquiry
          return this.props.updateServiceOrderEnquiry({uuid: enquiryList?.results?.[0]?.uuid, ...obj})
            .then(res => {
              this.updateLeadDetail('customer');
              resolve(res)
            }).catch(error => {
              reject(error)
            });
        } else {
          //add service order
          return this.props.addServiceOrderEnquiry(obj)
            .then(res => {
              this.updateLeadDetail('customer');
              resolve(res)
            }).catch(error => {
              reject(error)
            });
        }
      }
    })
  }

  //update leads detail
  updateLeadDetail = (role) => {
    return new Promise((resolve, reject) => {
      const { history } = this.props;
      const id = history?.location?.state?.query?.id;
      let authorizedUser_list = [];
      this.setState({loader: true})
      const basicDetail = JSON.parse(sessionStorage.getItem('basicDetail'));
      // update leads data
      if (!isEmpty(basicDetail)) {
        let isPrimaryExist = false;

        filter(basicDetail?.phone_numbers, (obj) => {
          if (obj.primary) {
            isPrimaryExist = true
          }
        })

        if (!isPrimaryExist) {
          basicDetail.phone_numbers[0].primary = true
        }

        map(basicDetail?.phone_numbers, (obj) => {
          if(!obj.uuid) delete obj?.uuid
        })

        if (!basicDetail?.address?.geo_location) {
          delete basicDetail?.address?.geo_location
        }

        if (!isEmpty(basicDetail.authorizedUser)) {
          authorizedUser_list = basicDetail.authorizedUser.map(x => x.user_name)
        }
        let is_dummy_email = false;
        if (basicDetail?.emails && basicDetail?.emails?.length > 0) {
          const email = basicDetail?.emails[0]?.email;
          const splitedEmail = email.split("@doody.com")[0];
          if ((/^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/).test(splitedEmail)) {
            is_dummy_email = true;
          }
        }
        
        let obj = {
          uuid: id,
          is_crm: true,
          zip_code: basicDetail?.zipcode,
          first_name: basicDetail?.firstName || '',
          hear_about_us: basicDetail?.hear_about_us || '',
          last_name: basicDetail?.lastName || '',
          address: [(basicDetail?.address?.street_number && basicDetail?.address?.route) ? {...basicDetail?.address, address: `${basicDetail?.address?.street_number} ${basicDetail?.address?.route}`} : basicDetail?.address],
          emailaddress_set: basicDetail?.emails,
          authorizedUser_list,
          lead_stage: role == "customer" ? role : basicDetail ?.leadData?.lead_stage,
          outreach: basicDetail?.leadData?.outreach,
          phone_numbers: basicDetail?.phone_numbers,
          role: [role],
          is_dummy_email: is_dummy_email
        }
        this.setState({loader: false})
        setTimeout(() => {
          return this.props.updateLeads(obj).then(res => {
            resolve(res)
          }).catch(error => {
            reject(error)
          });
        }, 1500);
      }
    })
  }


  // add call log
  addCallLog = () => {
    return new Promise((resolve, reject) => {
      const logCall = JSON.parse(sessionStorage.getItem('logCall'));
      const {history, CallLog } = this.props;
      const prevCallLog = CallLog?.logList?.results?.[0];
      const id = history?.location?.state?.query?.id;

      // add call log
      if (logCall?.next_callback
        && (
          new Date(prevCallLog?.next_callback).getTime() !== new Date(logCall.next_callback).getTime() ||
          prevCallLog?.notes !== logCall.notes ||
          prevCallLog?.reason !== (logCall.purpose || '')
        )
      ) {
        this.setState({loader: true})
        return this.props.addCallLog({
          notes: logCall.notes || '',
          next_callback: logCall.next_callback ? logCall.next_callback : null,
          reason: logCall.purpose || '',
          user: id,
          created_by_details: {
            uuid: JSON.parse(localStorage.getItem('authUser'))?.user?.uuid
          }
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        });
      } else {
        resolve('success')
      }
    })
  }

  setPrePayData = (extraData) => {
    this.setState({'prePaydata':extraData});
  }

   getPrePayData = () => {
     if(this.state.prePaydata && this.state.prePaydata.isPrePay && this.state.prePaydata.prepay_months && (parseInt(this.state.prePaydata.prepay_months) > 5) ){
       return true;
     } 
   }



  // common Price Calc
  priceCalc = (extraData = {}) => {
    this.setPrePayData(extraData);
    const {franchises, field_office_uuid} = this.state;
    const step1Data = JSON.parse(sessionStorage.getItem('step1'));
    const calcData = JSON.parse(sessionStorage.getItem('calcData'));
    const {dogCount, frequency, areaClean, propertyType, lastCleaned, add_ons, extra_pet, is_extra_pet} = step1Data || {};
    const {coupon_code = '', isPrePay = false, prepay_months = null} = extraData || {};
    const service_add_ons = []
    map(add_ons, obj => {
      if (obj?.add_on_uuid) service_add_ons.push({uuid: obj?.add_on_uuid, add_on_name: obj?.name, is_recurring: obj?.is_recurring || false})
    });
    const is_dog_count = is_extra_pet && parseInt(extra_pet) > 0 ? extra_pet : dogCount
    if ((franchises?.[0]?.uuid || field_office_uuid) && frequency && (is_dog_count) && propertyType && lastCleaned) {
      this.setState({loader: true})
      const data = {
        'field_office_uuid': franchises?.[0]?.uuid || field_office_uuid,
        'frequency': frequency,
        'pet_count': is_dog_count,
        'last_cleaned': lastCleaned,
        'property_type': propertyType,
        'areas_to_clean': areaClean,
        'add_ons': service_add_ons,
        'is_prepaid': isPrePay,
        'prepay_months': isPrePay ? prepay_months : null
      }

      if (coupon_code || calcData?.coupon_code) Object.assign(data, {'coupon_code': coupon_code ? coupon_code : calcData?.coupon_code});
      this.props.pricingCalculator(data)
    }
  }

  // add non serviceable enquiry
  onNonServiceableEnquiry = () => {
    const data = JSON.parse(sessionStorage.getItem('basicDetail'))
    let email = data?.emails?.find((x) => x.primary)

    if (email?.email && data?.zipcode) {
      this.setState({loader: true})
      setTimeout(() => {
        this.props.addNonServiceableEnquiry({email: email?.email, zip_code: data?.zipcode})
      }, 1000)
    }
  }

  renderTabs = () => {
    const {currentTab, isBackClick} = this.state;
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    switch (currentTab) {
    case 0:
      return (<ServiceInfo
        setLoader={this.setLoader}
        onTabChange={this.onTabChange}
        history={this.props.history}
        currentTab={currentTab}
        isBackClick={isBackClick}
        serviceOrderEnquiry={this.props.ServiceOrderEnquiry} // reducer
        onNonServiceableEnquiry={this.onNonServiceableEnquiry} //api

        // for basic details
        customerId={id}
        zipcodeCheck={this.props.ZipcodeCheck}
        getLeadById={this.props.getLeadById}
        lead={this.props.Lead}
        checkZipCode={this.props.checkZipCode}
        resetCheckZipcode={this.props.resetCheckZipcode}

        // pricing calc for sidebar
        // reducer
        PricingCalc={this.props.PricingCalc}
        CallLog={this.props.CallLog}
        DeletePhoneNumber={this.props.DeletePhoneNumber}
        GoogleApi={this.props.GoogleApi}
        // apis
        getServiceOrderEnquiry={this.props.getServiceOrderEnquiry}
        priceCalc={this.priceCalc}
        updateLeadDetail={this.updateLeadDetail}
        addCallLog={this.addCallLog}
        updateCallLog={this.props.updateCallLog}
        getCallLogList={this.props.getCallLogList}
        onAddEnquiry={this.onAddEnquiry}
        deletePhoneNumber={this.props.deletePhoneNumber}
        getGeocodeAddress={this.props.getGeocodeAddress}
        resetGeocodeAddress={this.props.resetGeocodeAddress}
        RepresentativeList={this.props.RepresentativeList} // reducer
        getRepresentativeList={this.props.getRepresentativeList}
      />
      )
    case 1:
      return (
        <BillingInfo
          setLoader={this.setLoader}
          onTabChange={this.onTabChange}
          history={this.props.history}
          currentTab={currentTab}
          serviceOrderEnquiry={this.props.ServiceOrderEnquiry} // reducer
          onNonServiceableEnquiry={this.onNonServiceableEnquiry} //api

          // for basic details
          customerId={id}
          zipcodeCheck={this.props.ZipcodeCheck}
          getLeadById={this.props.getLeadById}
          lead={this.props.Lead}
          checkZipCode={this.props.checkZipCode}
          resetCheckZipcode={this.props.resetCheckZipcode}

          // pricing calc for sidebar
          // reducer
          PricingCalc={this.props.PricingCalc}
          CallLog={this.props.CallLog}
          CardList={this.props.CardList}
          AddCard={this.props.AddCard}
          UpdateCard={this.props.UpdateCard}
          DeleteCard={this.props.DeleteCard}
          DeletePhoneNumber={this.props.DeletePhoneNumber}
          GoogleApi={this.props.GoogleApi}
          // apis
          getServiceOrderEnquiry={this.props.getServiceOrderEnquiry}
          priceCalc={this.priceCalc}
          onConvertToCustomer={this.onConvertToCustomer}
          addNewCard={this.props.addNewCard}
          updateLeadDetail={this.updateLeadDetail}
          addCallLog={this.addCallLog}
          updateCallLog={this.props.updateCallLog}
          getCallLogList={this.props.getCallLogList}
          onAddEnquiry={this.onAddEnquiry}
          getCardList={this.props.getCardList}
          deleteCard={this.props.deleteCard}
          deletePhoneNumber={this.props.deletePhoneNumber}
          getFieldOfficeById={this.props.getFieldOfficeById}
          getGeocodeAddress={this.props.getGeocodeAddress}
          resetGeocodeAddress={this.props.resetGeocodeAddress}
          getCustomerDetail={this.props.getCustomerDetail}
          RepresentativeList={this.props.RepresentativeList} // reducer
          getRepresentativeList={this.props.getRepresentativeList}
          fieldTechnicianFilter={this.props.FieldTechnicianFilter}
          getFieldTechnicianFilter={this.props.getFieldTechnicianFilter}
          ValidateCouponCode={this.props.ValidateCouponCode}
          validateCoupon={this.props.validateCoupon}
          getPrePayData = {this.getPrePayData}
        />
      )
    default:
      return (<ServiceInfo
        setLoader={this.setLoader}
        onTabChange={this.onTabChange}
        history={this.props.history}
        currentTab={currentTab}
        serviceOrderEnquiry={this.props.ServiceOrderEnquiry} // reducer
        onNonServiceableEnquiry={this.onNonServiceableEnquiry} //api

        // for basic details
        customerId={id}
        zipcodeCheck={this.props.ZipcodeCheck}
        getLeadById={this.props.getLeadById}
        lead={this.props.Lead}
        checkZipCode={this.props.checkZipCode}
        resetCheckZipcode={this.props.resetCheckZipcode}

        // pricing calc for sidebar
        PricingCalc={this.props.PricingCalc}
        priceCalc={this.priceCalc}
        updateLeadDetail={this.updateLeadDetail}
        addCallLog={this.addCallLog}
        updateCallLog={this.props.updateCallLog}
      />)
    }
  };

  render() {
    const {loader} = this.state;

    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header
            placeholder="Search for a ticket by client name, subject or keyword"
          />

          {/* Sidebar */}
          <Sidebar history={this.props.history} />
          <div className="fluid">
            {loader && <Loader />}
            {this.renderTabs()}
          </div>
        </div>
      </div>
    )
  }
}

export default QuoteNewService;
